import React, { useEffect, useState } from 'react'

const readPageLoaderTheme = () =>
  document.documentElement.getAttribute('data-theme') ||
  document.body.getAttribute('data-theme') ||
  localStorage.getItem('provio_theme') ||
  'dark'

const Pageloader = ({ isLoading }) => {
  const [theme, setTheme] = useState(readPageLoaderTheme)

  useEffect(() => {
    const syncTheme = (event) => {
      setTheme(event?.detail?.theme || readPageLoaderTheme())
    }

    window.addEventListener('provio-theme-change', syncTheme)
    window.addEventListener('storage', syncTheme)

    return () => {
      window.removeEventListener('provio-theme-change', syncTheme)
      window.removeEventListener('storage', syncTheme)
    }
  }, [])

  return (
    <>
      {isLoading && (
        <section
          className="ball-dots-container ui-page-loader"
          data-theme={theme}
          style={{
            background:
              theme === 'light'
                ? 'var(--ui-bg-canvas, #ffffff)'
                : 'var(--ui-dashboard-bg, #111111)',
          }}
        >
          <div className="ball-dot ui-page-loader__dot"></div>
          <div className="ball-dot ui-page-loader__dot"></div>
          <div className="ball-dot ui-page-loader__dot"></div>
          <div className="ball-dot ui-page-loader__dot"></div>
          <div className="ball-dot ui-page-loader__dot"></div>
        </section>
      )}
    </>
  )
}

export default Pageloader
